<template>
  <div class="container">
    <div class="col">
      <h4 class="alert-title">Page Not Found (404)</h4>
      <div class="page-not-exist">
        The requested page does not exist.
      </div>

      <div class="home">
        For going to the Homepage:
        <router-link to="/">Homepage</router-link>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "ErrorPage",
  data() {
    return {};
  },
};
</script>
<style scoped>
.container {
  width: 100%;
  height: 65vh;
  margin-top: 25px;
}
.col {
  padding-top: 30px;
}
h4 {
  font-size: 30px;
}
a {
  color: #ff6600;
}
.page-not-exist {
  font-size: 20px;
  text-align: center;
  margin: 10px;
}
.home {
  font-size: 20px;
  text-align: center;
  margin: 10px;
}
@media (max-width: 1200px) {
  .container {
    height: 72vh;
  }
  .col {
    padding-top: 200px;
  }
}
@media (max-width: 600px) {
  .home {
    font-size: 16px;
  }
  .page-not-exist {
    font-size: 16px;
  }
  h4 {
    font-size: 25px;
  }
  .container {
    height: 50vh;
  }
  .col {
    padding-top: 110px;
  }
}
@media (max-width: 363px) {
  .home {
    font-size: 12px;
  }
  .page-not-exist {
    font-size: 12px;
  }
  h4 {
    font-size: 20px;
  }
  .container {
    height: 35vh;
  }
}
</style>
